// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { DarkModeProvider } from './contexts/DarkModeContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Breadcrumbs from './components/Breadcrumbs';
import HomePage from './pages/HomePage';
import ArticlePage from './pages/ArticlePage';
import ArticlesListing from './pages/ArticlesListing';
import CalculatorPage from './pages/CalculatorPage';
import CalculatorsListing from './pages/CalculatorsListing';
import SearchPage from './pages/SearchPage';
import AboutUs from './pages/AboutUs';
import './App.css';

function App() {
  return (
    <DarkModeProvider>
      <Router>
        <div className="App min-h-screen bg-gradient-to-br from-orange-50 to-cyan-50 dark:from-slate-900 dark:to-slate-800">
          <Header />
          <Breadcrumbs />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/articles" element={<ArticlesListing />} />
              <Route path="/articles/:slug" element={<ArticlePage />} />
              <Route path="/calculators" element={<CalculatorsListing />} />
              <Route path="/calculators/:slug" element={<CalculatorPage />} />
              {/*<Route path="/calc-files/:slug" element={<CalculatorPage />} />*/}
              <Route path="/search" element={<SearchPage />} />
              <Route path="/aboutus" element={<AboutUs />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </DarkModeProvider>
  );
}

export default App;